import { render, staticRenderFns } from "./ConfigurationForm142.vue?vue&type=template&id=271a204f&scoped=true&lang=pug&"
import script from "./ConfigurationForm142.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationForm142.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationForm142.vue?vue&type=style&index=0&id=271a204f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271a204f",
  null
  
)

export default component.exports